var _excluded = ["mainChannel", "config"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getMainRangeChannel, getSecondaryRangeChannel, getSizeChannel, getVgPositionChannel, isXorY } from '../../../channel';
import { isFieldDef, isFieldOrDatumDef } from '../../../channeldef';
import { getMarkPropOrConfig } from '../../common';
import { positionOffset } from './offset';
import * as ref from './valueref';
import { scaledZeroOrMinOrMax } from './scaledZeroOrMinOrMax';
/**
 * Return encode for point (non-band) position channels.
 */
export function pointPosition(channel, model, _ref) {
  var defaultPos = _ref.defaultPos,
    vgChannel = _ref.vgChannel;
  var encoding = model.encoding,
    markDef = model.markDef,
    config = model.config,
    stack = model.stack;
  var channelDef = encoding[channel];
  var channel2Def = encoding[getSecondaryRangeChannel(channel)];
  var scaleName = model.scaleName(channel);
  var scale = model.getScaleComponent(channel);
  var _positionOffset = positionOffset({
      channel: channel,
      markDef: markDef,
      encoding: encoding,
      model: model,
      bandPosition: 0.5
    }),
    offset = _positionOffset.offset,
    offsetType = _positionOffset.offsetType;
  // Get default position or position from mark def
  var defaultRef = pointPositionDefaultRef({
    model: model,
    defaultPos: defaultPos,
    channel: channel,
    scaleName: scaleName,
    scale: scale
  });
  var valueRef = !channelDef && isXorY(channel) && (encoding.latitude || encoding.longitude) ?
  // use geopoint output if there are lat/long and there is no point position overriding lat/long.
  {
    field: model.getName(channel)
  } : positionRef({
    channel: channel,
    channelDef: channelDef,
    channel2Def: channel2Def,
    markDef: markDef,
    config: config,
    scaleName: scaleName,
    scale: scale,
    stack: stack,
    offset: offset,
    defaultRef: defaultRef,
    bandPosition: offsetType === 'encoding' ? 0 : undefined
  });
  return valueRef ? _defineProperty({}, vgChannel || channel, valueRef) : undefined;
}
// TODO: we need to find a way to refactor these so that scaleName is a part of scale
// but that's complicated. For now, this is a huge step moving forward.
/**
 * @return Vega ValueRef for normal x- or y-position without projection
 */
export function positionRef(params) {
  var channel = params.channel,
    channelDef = params.channelDef,
    scaleName = params.scaleName,
    stack = params.stack,
    offset = params.offset,
    markDef = params.markDef;
  // This isn't a part of midPoint because we use midPoint for non-position too
  if (isFieldOrDatumDef(channelDef) && stack && channel === stack.fieldChannel) {
    if (isFieldDef(channelDef)) {
      var bandPosition = channelDef.bandPosition;
      if (bandPosition === undefined && markDef.type === 'text' && (channel === 'radius' || channel === 'theta')) {
        // theta and radius of text mark should use bandPosition = 0.5 by default
        // so that labels for arc marks are centered automatically
        bandPosition = 0.5;
      }
      if (bandPosition !== undefined) {
        return ref.interpolatedSignalRef({
          scaleName: scaleName,
          fieldOrDatumDef: channelDef,
          // positionRef always have type
          startSuffix: 'start',
          bandPosition: bandPosition,
          offset: offset
        });
      }
    }
    // x or y use stack_end so that stacked line's point mark use stack_end too.
    return ref.valueRefForFieldOrDatumDef(channelDef, scaleName, {
      suffix: 'end'
    }, {
      offset: offset
    });
  }
  return ref.midPointRefWithPositionInvalidTest(params);
}
export function pointPositionDefaultRef(_ref3) {
  var model = _ref3.model,
    defaultPos = _ref3.defaultPos,
    channel = _ref3.channel,
    scaleName = _ref3.scaleName,
    scale = _ref3.scale;
  var markDef = model.markDef,
    config = model.config;
  return function () {
    var mainChannel = getMainRangeChannel(channel);
    var vgChannel = getVgPositionChannel(channel);
    var definedValueOrConfig = getMarkPropOrConfig(channel, markDef, config, {
      vgChannel: vgChannel
    });
    if (definedValueOrConfig !== undefined) {
      return ref.widthHeightValueOrSignalRef(channel, definedValueOrConfig);
    }
    switch (defaultPos) {
      case 'zeroOrMin':
        return zeroOrMinOrMaxPosition({
          scaleName: scaleName,
          scale: scale,
          mode: 'zeroOrMin',
          mainChannel: mainChannel,
          config: config
        });
      case 'zeroOrMax':
        return zeroOrMinOrMaxPosition({
          scaleName: scaleName,
          scale: scale,
          mode: {
            zeroOrMax: {
              widthSignal: model.width.signal,
              heightSignal: model.height.signal
            }
          },
          mainChannel: mainChannel,
          config: config
        });
      case 'mid':
        {
          var sizeRef = model[getSizeChannel(channel)];
          return _objectSpread(_objectSpread({}, sizeRef), {}, {
            mult: 0.5
          });
        }
    }
    // defaultPos === null
    return undefined;
  };
}
function zeroOrMinOrMaxPosition(_ref4) {
  var mainChannel = _ref4.mainChannel,
    config = _ref4.config,
    otherProps = _objectWithoutProperties(_ref4, _excluded);
  var scaledValueRef = scaledZeroOrMinOrMax(otherProps);
  var mode = otherProps.mode;
  if (scaledValueRef) {
    return scaledValueRef;
  }
  switch (mainChannel) {
    case 'radius':
      {
        if (mode === 'zeroOrMin') {
          return {
            value: 0
          }; // min value
        }
        var _mode$zeroOrMax = mode.zeroOrMax,
          widthSignal = _mode$zeroOrMax.widthSignal,
          heightSignal = _mode$zeroOrMax.heightSignal;
        // max of radius is min(width, height) / 2
        return {
          signal: "min(".concat(widthSignal, ",").concat(heightSignal, ")/2")
        };
      }
    case 'theta':
      return mode === 'zeroOrMin' ? {
        value: 0
      } : {
        signal: '2*PI'
      };
    case 'x':
      return mode === 'zeroOrMin' ? {
        value: 0
      } : {
        field: {
          group: 'width'
        }
      };
    case 'y':
      return mode === 'zeroOrMin' ? {
        field: {
          group: 'height'
        }
      } : {
        value: 0
      };
  }
}